import { changePage, fetchAppliances } from '#action/warehouse/appliance/appliance-paginated';
import { WarehouseFilterOptionService, ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { fetchProjectWarehouses } from '#action/list-filter';
import { uuidv4 } from '#helper';

const applianceStatuses = [
  { label: 'All', value: 'all', id: '1', default: true },
  { label: 'Active', value: '200', id: '200' },
  { label: 'Stopped', value: '300', id: '300' }
];

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search an application',
  relatedTo: 'warehouse',
  id: uuidv4()
};

const projectComponent = {
  type: 'MultipleSelect',
  name: 'project',
  label: 'Project',
  relatedTo: 'warehouse',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  afterChangeMultipleSelect: fetchProjectWarehouses,
  searchFields: ['title']
};

const warehouseComponent = {
  type: 'MultipleSelect',
  name: 'warehouse',
  label: 'Site',
  relatedTo: 'warehouse',
  id: uuidv4(),
  fetchOptionsService: WarehouseFilterOptionService,
  searchFields: ['label'],
  combinedWith: {
    entity: 'warehouse',
    fieldName: 'project',
    param: 'id'
  }
};

const applianceStatus = {
  type: 'RadioButtonsGroup',
  name: 'applianceStatus',
  label: 'Application status',
  relatedTo: 'warehouse',
  id: uuidv4(),
  options: applianceStatuses.map(o => new FilterOption(o, o.label))
};

const filterConfig = {
  customActions: {
    changePage,
    fetchFilterData: fetchAppliances
  },
  searchProps,
  components: [projectComponent, warehouseComponent, applianceStatus]
};

export default filterConfig;
